import { useState, useEffect } from 'react';

export default function About() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const productSlides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/fed92a4e5e70ad08153988f18676fb18.jpg',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=High%20quality%20Indian%20textile%20fabrics%20with%20vibrant%20colors%20and%20traditional%20patterns%2C%20cotton%20and%20silk%20materials%2C%20neatly%20folded%20and%20stacked%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20export%20quality%20textiles%2C%20commercial%20image&width=800&height=600&seq=about_prod2&orientation=landscape',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Premium%20dried%20mushrooms%20in%20wooden%20bowl%2C%20various%20types%20of%20dehydrated%20mushrooms%20including%20oyster%20milky%20and%20button%20varieties%2C%20natural%20brown%20colors%2C%20clean%20white%20background%2C%20professional%20food%20photography%20for%20export%2C%20high%20quality%20commercial%20product%20image&width=800&height=600&seq=about_prod3&orientation=landscape',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Premium%20black%20pepper%20corns%20in%20wooden%20bowl%20and%20scattered%20on%20white%20surface%2C%20fresh%20Indian%20spices%2C%20rich%20dark%20color%2C%20professional%20spice%20photography%20for%20export%20business%2C%20clean%20simple%20background%2C%20high%20quality%20commercial%20image&width=800&height=600&seq=about_prod4&orientation=landscape',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20golden%20turmeric%20powder%20and%20fresh%20turmeric%20roots%20on%20white%20surface%2C%20vibrant%20yellow%20color%2C%20Indian%20spices%20for%20export%2C%20professional%20product%20photography%2C%20clean%20minimal%20background%2C%20high%20quality%20commercial%20image&width=800&height=600&seq=about_prod5&orientation=landscape',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % productSlides.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [productSlides.length]);

  return (
    <section id="about" className="py-12 lg:py-16 bg-[#F9F7F4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Side */}
          <div>
            <p className="text-teal-600 text-xs font-semibold uppercase tracking-wider mb-4">
              ABOUT US
            </p>
            <h2 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              About JB GlobeX
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              JB GlobeX is an emerging export and import company based in India, focused on supplying high-quality agricultural and textile products to global markets. We specialize in sourcing premium quality products directly from trusted farmers and manufacturers to ensure consistent quality and reliability.
              <br /><br />
              Our main products include jaggery (blocks and powder), textiles, dried mushrooms (Oyster, Milky, and Button), black pepper (whole and powder), and turmeric (whole and powder). We also source and export a wide range of other products based on client requirements. JB GlobeX is committed to maintaining strict quality standards, hygienic processing, and reliable packaging to meet international export requirements.
              <br /><br />
              Our mission is to build long-term global partnerships by delivering authentic Indian premium quality products, competitive pricing, and a reliable supply chain you can count on.
            </p>
          </div>

          {/* Right Side — Product Image Slider */}
          <div className="relative w-full h-[520px] rounded-2xl overflow-hidden">
            {productSlides.map((slide, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}
              >
                <img
                  src={slide.image}
                  alt="JB GlobeX product"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            ))}

            {/* Dot Indicators */}
            <div className="absolute bottom-4 right-4 flex space-x-2 z-10">
              {productSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`rounded-full transition-all cursor-pointer ${index === currentSlide ? 'w-6 h-2 bg-teal-500' : 'w-2 h-2 bg-white/50'}`}
                />
              ))}
            </div>

            {/* Arrow buttons */}
            <button
              onClick={() => setCurrentSlide((prev) => (prev - 1 + productSlides.length) % productSlides.length)}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center z-10 cursor-pointer transition-all"
            >
              <i className="ri-arrow-left-s-line text-white text-lg"></i>
            </button>
            <button
              onClick={() => setCurrentSlide((prev) => (prev + 1) % productSlides.length)}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center z-10 cursor-pointer transition-all"
            >
              <i className="ri-arrow-right-s-line text-white text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
